module.exports = __webpack_public_path__ + "static/img/design.82584d18.png";